import {
  GET_LIST_REFERRAL_SOURCE,
  GET_LIST_REFERRAL_SOURCE_SUCCESS,
  GET_LIST_REFERRAL_SOURCE_ERROR,
  CREATE_REFERRAL_SOURCE_SUCCESS,
  CREATE_REFERRAL_SOURCE_ERROR,
  CREATE_REFERRAL_SOURCE_CLEAR,
  UPDATE_REFERRAL_SOURCE,
  UPDATE_REFERRAL_SOURCE_SUCCESS,
  UPDATE_REFERRAL_SOURCE_ERROR,
  UPDATE_REFERRAL_SOURCE_CLEAR,
  GET_REFERRAL_SOURCE,
  GET_REFERRAL_SOURCE_SUCCESS,
  GET_REFERRAL_SOURCE_ERROR,
  GET_REFERRAL_SOURCE_CLEAR,
  CLEAR_LIST_REFERRAL_SOURCE,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_SUCCESS,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_ERROR,
  GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_CLEAR,
  CREATE_REFERRAL_SOURCE,
} from "./actionTypes";
import { DEFAULT_OFFSET } from "../../../constants/pagination";

const initialState = {
  data: [],
  dataCoursesForOption: [],
  item: null,
  created: null,
  updated: null,
  removed: null,
  changedStatus: null,
  loadingTriggerCourse: null,
  pagination: { totalCount: 0, nextOffset: DEFAULT_OFFSET },
  error: "",
  loading: false,
  loadingForOption: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_REFERRAL_SOURCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_LIST_REFERRAL_SOURCE_SUCCESS:
      state = {
        ...state,
        data: [...state.data, ...action.payload.data],
        pagination: action.payload.pagination,
        loading: false,
      };
      break;
    case GET_LIST_REFERRAL_SOURCE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CREATE_REFERRAL_SOURCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CREATE_REFERRAL_SOURCE_SUCCESS:
      state = {
        ...state,
        created: action.payload,
        loading: false,
      };
      break;
    case CREATE_REFERRAL_SOURCE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case CREATE_REFERRAL_SOURCE_CLEAR:
      state = {
        ...state,
        created: null,
      };
      break;
    case UPDATE_REFERRAL_SOURCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case UPDATE_REFERRAL_SOURCE_SUCCESS:
      state = {
        ...state,
        updated: action.payload,
        loading: false,
      };
      break;
    case UPDATE_REFERRAL_SOURCE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case UPDATE_REFERRAL_SOURCE_CLEAR:
      state = {
        ...state,
        updated: null,
      };
      break;
    case GET_REFERRAL_SOURCE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_REFERRAL_SOURCE_SUCCESS:
      state = {
        ...state,
        item: action.payload,
        loading: false,
      };
      break;
    case GET_REFERRAL_SOURCE_ERROR:
      state = {
        ...state,
        loading: false,
      };
      break;
    case GET_REFERRAL_SOURCE_CLEAR:
      state = {
        ...state,
        data: [],
        item: null,
        loading: false,
      };
      break;
    // case REMOVE_BUNDLE:
    //   state = {
    //     ...state,
    //     loading: true,
    //   };
    //   break;
    // case REMOVE_BUNDLE_SUCCESS:
    //   state = {
    //     ...state,
    //     removed: action.payload,
    //     loading: false,
    //   };
    //   break;
    // case REMOVE_BUNDLE_ERROR:
    //   state = {
    //     ...state,
    //     loading: false,
    //   };
    //   break;
    // case REMOVE_BUNDLE_CLEAR:
    //   state = {
    //     ...state,
    //     created: null,
    //   };
    //   break;
    // case CHANGE_BUNDLE_STATUS:
    //   state = {
    //     ...state,
    //     loading: true,
    //   };
    //   break;
    // case CHANGE_BUNDLE_STATUS_SUCCESS:
    //   state = {
    //     ...state,
    //     data: state.data.map((item) => item.id === action.payload.id
    //       ? action.payload
    //       : item
    //     ),
    //     changedStatus: action.payload,
    //     loading: false,
    //   };
    //   break;
    case CLEAR_LIST_REFERRAL_SOURCE:
      state = { ...initialState };
      break;
    // case CHANGE_BUNDLE_STATUS_ERROR:
    //   state = {
    //     ...state,
    //     loading: false,
    //   };
    //   break;
    // case CHANGE_BUNDLE_STATUS_CLEAR:
    //   state = {
    //     ...state,
    //     changedStatus: null,
    //   };
    //   break;
    case GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE:
      state = {
        ...state,
        loadingForOption: true,
      }
      break;
    case GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_SUCCESS:
      state = {
        ...state,
        dataCoursesForOption: action.payload,
        loadingForOption: false
      }
      break
    case GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_ERROR:
      state = {
        ...state,
        loadingForOption: false,
      };
      break;
    case GET_COURSES_FOR_OPTION_FOR_REFERRAL_SOURCE_CLEAR:
      state = {
        ...state,
        dataCoursesForOption: []
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
